var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreeze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 19,
    viewBox: "0 0 94 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8427 13.5196C14.8427 14.2852 14.6934 14.9573 14.3949 15.5358C14.0964 16.1143 13.6817 16.5993 13.151 16.9906C12.6369 17.3819 12.0316 17.6797 11.335 17.8839C10.655 18.0881 9.92529 18.1901 9.1458 18.1901H0.612915V0.0693359H10.0663C10.6799 0.0693359 11.2355 0.205454 11.733 0.477692C12.2306 0.749929 12.6535 1.10724 13.0018 1.54963C13.3501 1.975 13.6154 2.46843 13.7978 3.02992C13.9969 3.57439 14.0964 4.12737 14.0964 4.68886C14.0964 5.57364 13.8808 6.40736 13.4496 7.19005C13.0184 7.95571 12.3881 8.52571 11.5589 8.90004C12.5706 9.20631 13.3666 9.75929 13.9471 10.559C14.5442 11.3417 14.8427 12.3285 14.8427 13.5196ZM11.3848 12.856C11.3848 12.5327 11.3267 12.2264 11.2106 11.9372C11.1111 11.6309 10.9701 11.3672 10.7877 11.146C10.6053 10.9248 10.3897 10.7547 10.1409 10.6356C9.89212 10.4994 9.61847 10.4314 9.31994 10.4314H4.04597V15.204H9.1458C9.46091 15.204 9.75115 15.1445 10.0165 15.0254C10.2984 14.9063 10.5389 14.7446 10.7379 14.5405C10.937 14.3193 11.0945 14.064 11.2106 13.7748C11.3267 13.4855 11.3848 13.1793 11.3848 12.856ZM4.04597 3.08096V7.64945H8.62338C9.20385 7.64945 9.6931 7.44527 10.0911 7.03691C10.5058 6.62856 10.7131 6.06707 10.7131 5.35244C10.7131 4.65484 10.5223 4.10185 10.1409 3.6935C9.77602 3.28514 9.31994 3.08096 8.77264 3.08096H4.04597Z",
    fill: "url(#paint0_linear_4540_19933)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.286 18.1901V3.9232H26.1273C26.8404 3.9232 27.4955 4.06782 28.0926 4.35708C28.6896 4.62931 29.2037 4.99513 29.6349 5.45453C30.0827 5.89692 30.4227 6.40736 30.6549 6.98587C30.9037 7.56437 31.0281 8.14288 31.0281 8.72138C31.0281 9.62317 30.7793 10.4484 30.2818 11.197C29.7842 11.9457 29.1125 12.4987 28.2667 12.856L31.8988 18.1901H28.4657L25.2317 13.5196H22.2962V18.1901H19.286ZM22.2962 10.8142H26.0526C26.5999 10.8142 27.056 10.6185 27.4209 10.2272C27.8023 9.81884 27.993 9.3169 27.993 8.72138C27.993 8.41512 27.935 8.13437 27.8189 7.87915C27.7028 7.62393 27.5453 7.40273 27.3462 7.21557C27.1638 7.02841 26.9482 6.88378 26.6994 6.78169C26.4507 6.6796 26.1936 6.62856 25.9282 6.62856H22.2962V10.8142Z",
    fill: "url(#paint1_linear_4540_19933)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6926 15.4848V18.1901H35.9705V3.9232H46.4936V6.62856H38.9806V9.66571H45.4736V12.1924H38.9806V15.4848H46.6926Z",
    fill: "url(#paint2_linear_4540_19933)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9194 15.4848V18.1901H51.1973V3.9232H61.7204V6.62856H54.2075V9.66571H60.7004V12.1924H54.2075V15.4848H61.9194Z",
    fill: "url(#paint3_linear_4540_19933)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5535 15.8676L74.2356 6.62856H65.8022V3.9232H77.7433V6.24572L69.3348 15.4848H77.7931V18.1901H65.5535V15.8676Z",
    fill: "url(#paint4_linear_4540_19933)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.029 15.4848V18.1901H82.3069V3.9232H92.83V6.62856H85.3171V9.66571H91.81V12.1924H85.3171V15.4848H93.029Z",
    fill: "url(#paint5_linear_4540_19933)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4540_19933",
    x1: 0.612915,
    y1: 0.0693359,
    x2: 17.9661,
    y2: 45.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4540_19933",
    x1: 0.612915,
    y1: 0.0693359,
    x2: 17.9661,
    y2: 45.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4540_19933",
    x1: 0.612915,
    y1: 0.0693359,
    x2: 17.9661,
    y2: 45.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4540_19933",
    x1: 0.612915,
    y1: 0.0693359,
    x2: 17.9661,
    y2: 45.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4540_19933",
    x1: 0.612915,
    y1: 0.0693359,
    x2: 17.9661,
    y2: 45.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4540_19933",
    x1: 0.612915,
    y1: 0.0693359,
    x2: 17.9661,
    y2: 45.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01E5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreeze);
export default __webpack_public_path__ + "static/media/breeze.58421a59d07af1bafb36f97960ff8c73.svg";
export { ForwardRef as ReactComponent };